'use client';

import dynamic from 'next/dynamic';
import { Container } from '@weareconceptstudio/core';

//* Styles
import SuccessStoriesTemplateStyle from './style';

//* Components
const List = dynamic(() => import('./components/List'));

const SuccessStoriesTemplate = ({ pageData }) => {
	const { title } = pageData.content;

	return (
		<SuccessStoriesTemplateStyle>
			<Container>
				<List title={title} />
			</Container>
		</SuccessStoriesTemplateStyle>
	);
};

export default SuccessStoriesTemplate;
